export const decodeHtml = (str: string): string =>
  str.replace(/&gt;/g, ">").replace(/&lt;/g, "<").replace(/&amp;/g, "&");
